<template>
  <div>
    <van-dialog
      v-model="visible"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="dialog"
      :style="{
        background: `url(${backgroundImage}) no-repeat`
      }"
    >
      <div @click="removeClick" class="removeImage">
        <van-image :src="removeImage"> </van-image>
      </div>
      <div v-if="titleImage" class="title">
        <van-image :src="titleImage"> </van-image>
      </div>
      <div class="dialogWarp">
        <van-image :src="textImage"> </van-image>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'checkInDialog',
  props: {
    visible: Boolean,
    titleImage: String,
    backgroundImage: String,
    removeImage: String,
    textImage: String
  },
  methods: {
    removeClick(val) {
      this.$emit('changeVisible', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  background-size: 100% 100% !important;
  .title {
    padding: 2rem;
    padding-bottom: 0rem;
    /deep/ .van-image {
      width: 30%;
      display: block;
      margin: 0 auto;
    }
  }
}
.removeImage {
  position: absolute;
  width: 20px;
  z-index: 1000;
  top: 15px;
  right: 15px;
}
.dialogWarp {
  height: 400px;
  //   padding: 2.5rem;
  //   padding-top: 1rem;
  position: relative;
  /deep/ .van-image {
    position: absolute;
    width: 75%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/checkInDialog/index.vue